import { render, staticRenderFns } from "./PlaceholderMappingEditor.vue?vue&type=template&id=67f08bb9&scoped=true"
import script from "./PlaceholderMappingEditor.vue?vue&type=script&lang=js"
export * from "./PlaceholderMappingEditor.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderMappingEditor.vue?vue&type=style&index=0&id=67f08bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f08bb9",
  null
  
)

export default component.exports